module.exports = __webpack_public_path__ + "img/prepare-lesson-up.41c48866.svg";